import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './component/App'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
